import { render, staticRenderFns } from "./BtnLockResource.yaml?vue&type=template&id=01369e48&component"
import script from "./BtnLockResource.yaml?vue&type=script&lang=ts&component"
export * from "./BtnLockResource.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports